module.exports = __webpack_public_path__ + "/818a8c7e5e77b8d5d140968db631af82.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/assets/secure_badge_@2x.png
 ** module id = 1099
 ** module chunks = 0
 **/